import React from 'react';
import { Mail, Phone, MapPin } from 'lucide-react';
import { companyInfo } from '../mock';

const Contact = () => {
  const contactInfo = [
    {
      icon: Phone,
      title: 'Telefon',
      value: companyInfo.phone,
      link: `tel:${companyInfo.phone}`
    },
    {
      icon: Mail,
      title: 'Email',
      value: companyInfo.email,
      link: `mailto:${companyInfo.email}`
    },
    {
      icon: MapPin,
      title: 'Adresa',
      value: companyInfo.address,
      link: null
    }
  ];

  return (
    <section id="contact" className="py-20 bg-gradient-to-b from-gray-50 to-white">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <span className="text-amber-600 font-semibold text-sm uppercase tracking-wide">Kontakt</span>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mt-4 mb-6">
            Kontaktirajte nas
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed">
            Imate pitanja ili želite saznati više? Javite nam se!
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto">
          {contactInfo.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="bg-white rounded-xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 text-center border border-gray-100"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-amber-500 to-amber-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-md">
                  <Icon className="text-white" size={28} />
                </div>
                <h3 className="font-bold text-xl text-gray-900 mb-3">{item.title}</h3>
                {item.link ? (
                  <a
                    href={item.link}
                    className="text-gray-600 hover:text-amber-600 transition-colors text-lg font-medium"
                  >
                    {item.value}
                  </a>
                ) : (
                  <p className="text-gray-600 text-lg">{item.value}</p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Contact;